const launchProductTourDemo = (onclick: () => void) => (event: React.MouseEvent<HTMLElement>) => {
  if (!window.Intercom) return
  event.preventDefault()
  onclick()
  window.Intercom('startTour', 2352)
}

export default { launchProductTourDemo }
